import { Text } from "../../components/Text";
import DashboardRecord from "./DashboardRecord";
import { useEffect, useState } from "react";
import TransactionAlert from "../../components/TransactionAlert";
import { Link, useParams } from "react-router-dom";
import Loader from "../../components/Loader";
import DashboardCard from "../../components/Cards/DashboardCards";
import { getDate } from "../../utils/datemaker";
import { underlineStyle } from "../../utils/commonStyles";
import { useSelector, useDispatch } from "react-redux";

import { Skeleton } from "primereact/skeleton";
import { getOverAllCount } from "../../reducers/analyticSlice";

export const Dashboard = () => {
  let { transactionid } = useParams();
  const [status, setStatus] = useState(transactionid);
  const [transaction, setTransaction] = useState(false);
  const { overAllCount, loading } = useSelector((state) => state.analytic);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    let tzoffset = new Date().getTimezoneOffset() * 60000;
    const date = {
      startDate: fromDate
        ? new Date(fromDate - tzoffset).toISOString().substring(0, 10)
        : fromDate,
      endDate: toDate
        ? new Date(toDate - tzoffset).toISOString().substring(0, 10)
        : toDate,
    };

    dispatch(getOverAllCount(date))
      .unwrap()
      .catch(() => {
        //show toast from here
      });
  }, []);
  const loderSkaleton = () => {
    return (
      <Skeleton
        width={"5rem"}
        height={"3rem"}
        borderRadius={"4px"}
        className="mb-2"
      />
    );
  };

  const { proUsers, standardUsers, testUsers, allUsers } = overAllCount;
  return (
    <div>
      <TransactionAlert
        transaction={transaction}
        setTransaction={setTransaction}
        status={status}
      />
      <div className={`w-11 m-auto h-auto`}>
        <div className="py-3">
          <Text type={"heading"}>
            <span style={underlineStyle}>Dashboard Analytics</span>
          </Text>
          <div className="flex justify-content-center lg:justify-content-between gap-3 align-items-center pt-3 flex-wrap">
            <DashboardCard
              count={loading ? loderSkaleton() : allUsers}
              title={"Total Customers"}
            />
            <DashboardCard
              count={loading ? loderSkaleton() : proUsers}
              title={"Pro Customers"}
            />
            <DashboardCard
              count={loading ? loderSkaleton() : standardUsers}
              title={"Standard Customers"}
            />
            <DashboardCard
              count={loading ? loderSkaleton() : testUsers}
              title={"Trail Customers"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
